module.exports = __webpack_public_path__ + "static/media/bg-profile.997df51d.png";